import { addToCartFromCard } from "./utilities/form-product"
import "./components/drawer"
import "./components/quantity"
import "./utilities/utils"
import "./utilities/sticky-engine"
import "./utilities/truncatable"
import "./utilities/marquee"

// Function to load icons
export function loadIcons() {
  document.querySelectorAll(".icon").forEach((icon) => {
    icon.classList.add("loaded")
  })
}

// Scroll animations for sections
function initScrollAnimations() {
  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    // Fallback: show all sections immediately
    document.querySelectorAll('.shopify-section').forEach(section => {
      section.querySelector('.section__wrapper')?.classList.add('in-view')
    })
    return
  }

  const observerOptions = {
    threshold: 0.01, // Trigger when 1% of element is visible
    rootMargin: '0px 0px -50px 0px' // Trigger 50px before element enters viewport
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.querySelector('.section__wrapper')?.classList.add('in-view')

        // Trigger image animations (CSS handles the delay)
        const images = entry.target.querySelectorAll('img:not(.image-loaded):not(.no-animate):not([data-no-animate])')
        images.forEach(img => {
          if (!img.closest('.no-animate')) {
            animateImageDelayed(img)
          }
        })

        // Optional: stop observing after animation to improve performance
        // observer.unobserve(entry.target)
      } else {
        // Optional: remove class when out of view (for repeat animations)
        // entry.target.classList.remove('in-view')
      }
    })
  }, observerOptions)

  // Observe all shopify sections
  document.querySelectorAll('.shopify-section').forEach((section) => {
    observer.observe(section)
  })
}

// Handle dynamically added sections (for theme editor)
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initScrollAnimations()
    // Re-bind drawer triggers when sections re-render in Theme Editor
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('drawer:reinitialize'))
    })
  })
}

// Image load animations
function initImageAnimations() {
  function animateImage(img) {
    // Skip if already animated or marked to skip
    if (img.classList.contains('image-loaded') ||
        img.classList.contains('no-animate') ||
        img.hasAttribute('data-no-animate') ||
        img.closest('.no-animate')) {
      return
    }

    // Only animate images in sections that are already visible
    const parentSection = img.closest('.shopify-section')
    if (parentSection && !parentSection.classList.contains('in-view')) {
      return // Skip animation, section hasn't animated in yet
    }

    // Check if image is already loaded
    if (img.complete && img.naturalHeight !== 0) {
      // Image is already loaded
      img.classList.add('image-loaded')
    } else {
      // Image is still loading, wait for load event
      const handleLoad = () => {
        img.classList.add('image-loaded')
        img.removeEventListener('load', handleLoad)
        img.removeEventListener('error', handleLoad)
      }

      img.addEventListener('load', handleLoad)
      img.addEventListener('error', handleLoad) // Show even if failed to load
    }
  }

  // Function specifically for delayed animation (called from section observer)
  window.animateImageDelayed = function(img) {
    // Skip if already animated or marked to skip
    if (img.classList.contains('image-loaded') ||
        img.classList.contains('no-animate') ||
        img.hasAttribute('data-no-animate') ||
        img.closest('.no-animate')) {
      return
    }

    // Check if image is already loaded
    if (img.complete && img.naturalHeight !== 0) {
      // Image is already loaded
      img.classList.add('image-loaded')
    } else {
      // Image is still loading, wait for load event
      const handleLoad = () => {
        img.classList.add('image-loaded')
        img.removeEventListener('load', handleLoad)
        img.removeEventListener('error', handleLoad)
      }

      img.addEventListener('load', handleLoad)
      img.addEventListener('error', handleLoad) // Show even if failed to load
    }
  }

  // Animate existing images
  document.querySelectorAll('img').forEach(animateImage)

  // Handle dynamically added images
  const imageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the node itself is an image
          if (node.tagName === 'IMG') {
            animateImage(node)
          }
          // Check for images within the added node
          node.querySelectorAll && node.querySelectorAll('img').forEach(animateImage)
        }
      })
    })
  })

  // Start observing
  imageObserver.observe(document.body, {
    childList: true,
    subtree: true
  })

  // Handle theme editor changes
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      // Small delay to ensure images are in DOM
      setTimeout(() => {
        document.querySelectorAll('img:not(.image-loaded)').forEach(animateImage)
      }, 50)
    })
  }
}

// Initialize scroll animations after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initScrollAnimations()
  initImageAnimations()
})

document.addEventListener("DOMContentLoaded", function () {
  loadIcons()

  document.querySelectorAll('a[target="_blank"]').forEach((el) => {
    el.innerHTML =
      el.innerHTML +
      '<span class="visually-hidden"> ' +
      accessibilityNoticeNewTab +
      "</span>"
  })

  addToCartFromCard()
})
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options["method"] || "post"
  var params = options["parameters"] || {}

  var form = document.createElement("form")
  form.setAttribute("method", method)
  form.setAttribute("action", path)

  for (var key in params) {
    var hiddenField = document.createElement("input")
    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("name", key)
    hiddenField.setAttribute("value", params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default")
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default")
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute("data-provinces")
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none"
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option")
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ""
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option")
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

function playPauseHostedVideo() {
  let videos = document.querySelectorAll("video")
  videos.forEach((video) => {
    // We can only control playback if video is muted
    video.muted = true

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            video.pause()
          } else if (video.autoplay == true) {
            // Only attempt to play if video is not already playing
            if (video.paused) {
              // Handle the play promise
              video.play().catch(error => {
                // Ignore AbortError as it's expected when quickly switching between play/pause
                if (error.name !== 'AbortError') {
                  console.error("Error playing video:", error)
                }
              })
            }
          }
        })
      },
      { threshold: 0 }
    )
    observer.observe(video)
  })

  let hoverPlayVideos = document.querySelectorAll("video.hover-play")
  hoverPlayVideos.forEach((video) => {
    const card = video.closest('.card')
    video.pause() // Pause all hover-play videos initially

    if(card) {
      card.addEventListener("mouseenter", () => {
        video.play().catch(error => {
          if (error.name !== 'AbortError') {
            console.error("Error playing video:", error)
          }
        })
      })

      card.addEventListener("mouseleave", () => {
        video.pause()
      })
    } else {
      video.addEventListener("mouseenter", () => {
        video.play().catch(error => {
          if (error.name !== 'AbortError') {
            console.error("Error playing video:", error)
          }
        })
      })

      video.addEventListener("mouseleave", () => {
        video.pause()
      })
    }
  })
}

playPauseHostedVideo()

//video lazyload
const enableLazyVideos = function () {
  const lazyVideos = [].slice.call(document.querySelectorAll("video"))
  lazyVideos.forEach((lazyVideo) => {
    const poster = lazyVideo.parentElement.querySelector(
      ".figure--video__poster"
    )

    if (poster) {
      poster.addEventListener("click", () => {
        poster.classList.add("hidden")
        lazyVideo.play()
      })
    }
  })

  var externalVideos = [].slice.call(
    document.querySelectorAll(".figure--video-external")
  )
  if ("IntersectionObserver" in window) {
    var externalVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (container) {
        if (container.isIntersecting) {
          let videoType = container.target.dataset.type

          if (videoType == "vimeo") {
            fetch(
              "http://vimeo.com/api/v2/video/" +
                container.target.dataset.id +
                ".json"
            )
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`HTTP error ${response.status}`)
                }
                return response.json()
              })
              .then((data) => {
                container.target.querySelector(
                  ".figure--video__external-poster-image"
                ).src = data[0].thumbnail_large
              })
          }

          container.target.addEventListener("click", function () {
            if (!container.target.querySelector("iframe")) {
              let videoType = this.dataset.type
              let iframe = document.createElement("iframe")
              iframe.setAttribute("frameborder", "0")
              iframe.setAttribute("allowfullscreen", "")
              iframe.setAttribute("allow", "autoplay")

              if (videoType == "youtube") {
                iframe.setAttribute("id", "youtube")
                iframe.setAttribute(
                  "src",
                  "https://www.youtube.com/embed/" +
                    this.dataset.id +
                    this.dataset.videotags +
                    "rel=0&showinfo=0&autoplay=1&enablejsapi=1"
                )
              } else {
                iframe.setAttribute(
                  "src",
                  "https://player.vimeo.com/video/" +
                    this.dataset.id +
                    this.dataset.videotags +
                    "rel=0&showinfo=0&autoplay=1"
                )
              }

              this.appendChild(iframe)
              setTimeout(() => {
                this.querySelector(".figure--video__poster").classList.add(
                  "hidden"
                )
              }, 350);

            }
          })
        } else {
          //based on https://www.michaelsmyth.co.uk/pausing-youtube-vimeo-videos-postmessage/
          //but for some reason does not work
          //perhaps because we initialize the iframe on click
          if (container.target.querySelector("iframe")) {
            let videoType = container.target.dataset.type
            let iframe = container.target.querySelectorAll("iframe")
            if (videoType == "youtube") {
              var command = {
                event: "command",
                func: "pauseVideo",
              }
              iframe[0].contentWindow.postMessage(JSON.stringify(command), "*")
            } else if (videoType == "vimeo") {
              var command = {
                method: "pause",
                value: "true",
              }
              iframe[0].contentWindow.postMessage(JSON.stringify(command), "*")
            }
          }
        }
      })
    })

    externalVideos.forEach(function (externalVideo) {
      externalVideoObserver.observe(externalVideo)
    })
  }
}

enableLazyVideos()

// open closed details elements for printing
window.addEventListener("beforeprint", () => {
  const allDetails = document.body.querySelectorAll("details")
  const allImages = document.body.querySelectorAll("img")
  for (let i = 0; i < allDetails.length; i++) {
    if (allDetails[i].open) {
      allDetails[i].dataset.open = "1"
    } else {
      allDetails[i].setAttribute("open", "")
    }
  }
  for (let i = 0; i < allImages.length; i++) {
    allImages[i].dataset.open = "1"
  }
})

// after printing close details elements not opened before
window.addEventListener("afterprint", () => {
  const allDetails = document.body.querySelectorAll("details")
  for (let i = 0; i < allDetails.length; i++) {
    if (allDetails[i].dataset.open) {
      allDetails[i].dataset.open = ""
    } else {
      allDetails[i].removeAttribute("open")
    }
  }
})

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    enableLazyVideos()
    document.querySelectorAll(".icon").forEach((icon) => {
      icon.classList.add("loaded")
    })
  })
}

class VariantSelects extends HTMLElement {
  constructor() {
    super()

    this.addEventListener("change", (event) => {
      const syncEvent = new CustomEvent("variant-update", {
        detail: { event, section: this.dataset.section, product: this.dataset.product, block: this.dataset.block },
        bubbles: true,
      })

      this.dispatchEvent(syncEvent)
    })

    document.addEventListener("variant-update", (e) => {
      if (this.dataset.section === e.detail.section && this.dataset.product === e.detail.product && this.dataset.block === e.detail.block) {
        if (e.detail.event.target.closest("variant-selects") !== this) {
          this.syncSelection(e.detail.event.target)
        }

        this.onVariantChange()
      }
    })

    this.isCardBasedProductForm = this.closest(".card__content") !== null
    this.initializeIdentifiers()
  }

  initializeIdentifiers() {
    if (this.dataset.product) {
      this.mainProductUniqueIdentifier = "main-product" + "-" + this.dataset.product
      this.uniqueIdentifier = this.dataset.section + "-" + this.dataset.product + (this.dataset.block ? "-" + this.dataset.block : "")
    }
  }

  connectedCallback() {
    this.initializeIdentifiers()
    this.updateSwatchLegend()
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    if (this.currentVariant) {
      this.updateVariantStatuses()
      this.updateMedia()
      this.updateURL()
      this.updateLinks()
      this.renderProductInfo()
      this.updateVariantInput()
      this.updateAddToCart()
      this.updateSwatchLegend()
      this.updateStickyVariant()
    } else if (this.currentVariant === undefined) {
      this.setUnavailable()
    }
  }

  updateStickyVariant() {
    const stickyVariantTitle = document.querySelector(`#sticky-variant-${this.uniqueIdentifier}`)
    if (stickyVariantTitle) {
      stickyVariantTitle.textContent = this.currentVariant.title
    }
  }

  updateSwatchLegend() {
    // For swatch and pill pickers
    const fieldsets = this.querySelectorAll('.main-product__fieldset--image_swatches, .main-product__fieldset--color_swatches, .main-product__fieldset--pills');
    fieldsets.forEach(fieldset => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      const legend = fieldset.querySelector('legend');
      if (legend) {
        // Use data-option-name if present, else fallback to legend's text before colon
        const optionName = legend.dataset.optionName || legend.textContent.split(':')[0].trim();
        if (checkedInput) {
          const label = checkedInput.closest('label');
          const value = label ? label.getAttribute('title') : checkedInput.value;
          legend.textContent = `${optionName}: ${value}`;
        } else {
          // fallback: just show the option name
          legend.textContent = optionName;
        }
      }
    });
  }

  syncSelection(target) {
    const { name, value } = target
    const inputElement = this.querySelector(`[name="${name}"]`)
    const inputElementTagName = inputElement?.tagName
    if (!inputElement) return

    if (inputElementTagName === "SELECT") {
      this.querySelector(`[name="${name}"] [value="${value}"]`).selected = true
    } else {
      this.querySelector(`[name="${name}"][value="${value}"]`).checked = true
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select, fieldset"), (element) => {
      if (element.tagName === "SELECT") {
        return element.value
      } else if (element.tagName === "FIELDSET") {
        return Array.from(element.querySelectorAll("input")).find((radio) => radio.checked)?.value
      }
    })
  }

  updateMasterId() {
    if (this.options.includes(undefined)) {
      // if any option is undefined, reset currentVariant and exit
      this.currentVariant = null
      return
    }

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateVariantStatuses() {
    const selectedOptionOne = this.querySelector(":checked").value
    const selectedOptionOneVariants = this.getVariantData().filter((variant) => {
      return variant.options[0] === selectedOptionOne
    })

    const productVariantSelects = this.getProductVariantSelects()

    productVariantSelects.forEach((variantSelectElement) => {
      const variantSelectInputElements = variantSelectElement.querySelectorAll("select, fieldset")
      variantSelectInputElements.forEach((variantSelectInputElement, index) => {
        if (index === 0) return

        const optionInputs = variantSelectInputElement.querySelectorAll(
          'input[type="radio"], option',
        )
        const previousOptionSelected =
          variantSelectInputElements[index - 1].querySelector(":checked").value
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
          )
          .map((variantOption) => variantOption[`option${index + 1}`])
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      })
    })
  }

  setInputAvailability(optionInputs, availableValuesList) {
    optionInputs.forEach((element) => {
      const value = element.getAttribute("value")
      const availableElement = availableValuesList.includes(value)

      if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.productStrings.unavailable_with_option.replace("[value]", value)
      }
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    if (!this.uniqueIdentifier) {
      this.initializeIdentifiers()
    }

    if (!this.uniqueIdentifier) return

    const productGallery = document.querySelector(`#gallery-${this.uniqueIdentifier}`)

    const variantGalleryStyle = productGallery?.dataset?.variantStyle || 'default'

    if (this.currentVariant.featured_media) {
      const currentVariantFeaturedMediaId = this.currentVariant.featured_media.id
      if(variantGalleryStyle == 'default') {
        if (productGallery && productGallery.swiper && productGallery.swiper.initialized) {
          const slides = productGallery.swiper.virtual.slides.length > 0 ? productGallery.swiper.virtual.slides : productGallery.swiper.slides

          const index = Array.from(slides).findIndex(slide =>
            slide.dataset.id == currentVariantFeaturedMediaId
          );

          if (index !== -1) {
            productGallery.swiper.slideToLoop(index)
          }
        } else {
          const targetSlide = productGallery.querySelector(
            `[data-id="${currentVariantFeaturedMediaId}"]`,
          )

          // Check if target slide exists before prepending
          if (targetSlide) {
            productGallery.prepend(targetSlide)
          }
        }
      } else if(variantGalleryStyle == 'variant') {
        const targetSlide = productGallery.querySelector(
          `[data-id="${currentVariantFeaturedMediaId}"]`,
        )

        // Check if target slide exists before prepending
        if (targetSlide) {
          productGallery.firstChild.classList.add('u-hide')
          targetSlide.classList.remove('u-hide')
          productGallery.prepend(targetSlide)
        }
      }

      // Show the correct sticky product image
      const stickyProductGallery = document.querySelector(
        `#sticky-gallery-${this.uniqueIdentifier}`,
      )
      if (stickyProductGallery) {
        const stickyImages = stickyProductGallery.querySelectorAll(".sticky-add-to-cart__image")
        const variantId = this.currentVariant.id

        stickyImages.forEach((imgElement) => {
          if (imgElement.dataset.variantId == variantId) {
            imgElement.classList.remove("u-hide")
          } else {
            imgElement.classList.add("u-hide")
          }
        })
      }
    }
  }

  updateURL() {
    if (this.dataset.updateUrl === "false") return
    const newURL = `${this.dataset.url}?variant=${this.currentVariant.id}`
    window.history.replaceState({}, "", newURL)
  }

  updateLinks() {
    if (!this.isCardBasedProductForm) return
    const viewProductButton = this.closest(".card__content").querySelector(".button--view-product")

    if (viewProductButton?.tagName === "A") {
      viewProductButton.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  renderProductInfo() {
    const priceDestination = document.getElementById(`price-${this.uniqueIdentifier}`)
    if (priceDestination) {
      if (priceDestination.classList.contains("price--on-sale")) {
        priceDestination
          .querySelectorAll(".price__sale .price-item")
          .forEach((el) => el.classList.add("skeleton-loading"))
      } else {
        priceDestination.querySelector(".price__regular").classList.add("skeleton-loading")
      }
    }

    const stickyPriceDestination = document.getElementById(`sticky-price-${this.uniqueIdentifier}`)
    if (stickyPriceDestination) {
      if (stickyPriceDestination.classList.contains("price--on-sale")) {
        stickyPriceDestination
          .querySelectorAll(".price__sale .price-item")
          .forEach((el) => el.classList.add("skeleton-loading"))
      } else {
        stickyPriceDestination.querySelector(".price__regular").classList.add("skeleton-loading")
      }
    }

    const pickupDestination = document.getElementById(
      `pickup-availability-${this.uniqueIdentifier}`,
    )
    pickupDestination?.querySelector('.skeleton-loading-wrapper')?.classList.add("skeleton-loading")

    const stockStatusDestination = document.getElementById(`stock-status-${this.uniqueIdentifier}`)
    stockStatusDestination?.classList.add("skeleton-loading")

    const pickupModalDestination = document.getElementById(
      `pickup-availability-modal-${this.mainProductUniqueIdentifier}`,
    )

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html")
        const priceSource = html.getElementById(`price-${this.mainProductUniqueIdentifier}`)

        if (stockStatusDestination) {
          const stockStatusSource = html.getElementById(
            `stock-status-${this.mainProductUniqueIdentifier}`,
          )

          if (stockStatusSource) {
            stockStatusDestination.classList.remove("u-invisible")
            stockStatusDestination.innerHTML = stockStatusSource.innerHTML
            stockStatusDestination.classList = stockStatusSource.classList
          } else {
            stockStatusDestination?.classList.add("u-invisible")
          }
        }

        if (priceSource && priceDestination) {
          priceDestination.classList.remove("u-invisible")
          priceDestination.innerHTML = priceSource.innerHTML
          priceDestination.classList = priceSource.classList
        } else {
          priceDestination?.classList.add("u-invisible")
        }

        if (stickyPriceDestination) {
          const stickyPriceSource = html.getElementById(
            `sticky-price-${this.mainProductUniqueIdentifier}`,
          )

          if (stickyPriceSource) {
            stickyPriceDestination.classList.remove("u-invisible")
            stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML
            stickyPriceDestination.classList = stickyPriceSource.classList
          } else {
            stickyPriceDestination?.classList.add("u-invisible")
          }
        }

        if (pickupDestination) {
          const pickupSource = html.getElementById(
            `pickup-availability-${this.mainProductUniqueIdentifier}`,
          )

          if (pickupSource) {
            pickupDestination.innerHTML = pickupSource.innerHTML
            pickupDestination.classList = pickupSource.classList
          }
        }

        if (pickupModalDestination) {
          const pickupModalSource = html.getElementById(
            `pickup-availability-modal-${this.mainProductUniqueIdentifier}`,
          )

          if (pickupModalSource) {
            pickupModalDestination.innerHTML = pickupModalSource.innerHTML

          }
        }

        document.dispatchEvent(new CustomEvent('drawer:reinitialize'))
      })
  }

  updateAddToCart() {
    const productForm = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`)

    if (!productForm) return

    if (this.currentVariant.available) {
      productForm.forEach((form) => {
        const addButton = form.querySelector('[name="add"]')
        const addButtonText = form.querySelector('[name="add"] > span:not(.cart-icon)')
        if (!addButton) return

        addButton.removeAttribute("disabled")
        addButtonText.textContent = `${cartStrings.addToCart}`
        addButton.classList.remove("u-hide")

        // Available again — hide the "Notify when back in stock" button.
        const notifyButton = form.querySelector("[data-notify-back-in-stock]")
        if (notifyButton) notifyButton.classList.add("u-hide")
      })
    } else {
      productForm.forEach((form) => {
        const addButton = form.querySelector('[name="add"]')
        const addButtonText = form.querySelector('[name="add"] > span:not(.cart-icon)')
        if (!addButton) return

        addButton.setAttribute("disabled", "disabled")
        addButtonText.textContent = `${cartStrings.soldOut}`

        // Sold out — swap the add-to-cart button for the notify button, if present.
        const notifyButton = form.querySelector("[data-notify-back-in-stock]")
        if (notifyButton) {
          notifyButton.dataset.variantId = this.currentVariant.id
          notifyButton.classList.remove("u-hide")
          addButton.classList.add("u-hide")
        }
      })
    }
  }

  setUnavailable() {
    const productForm = document.querySelectorAll(
      `.form-product-${this.uniqueIdentifier}`
    )
    const stock = document.getElementById(
      `stock-status-${this.uniqueIdentifier}`
    )
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]')
      const addButtonText = form.querySelector(
        '[name="add"] > span:not(.cart-icon)'
      )
      if (!addButton) return
      addButtonText.textContent = `${cartStrings.unavailable}`
      addButton.setAttribute("disabled", "disabled")
      addButton.classList.remove("u-hide")
      if (stock) stock.dataset.state = "unavailable"

      // No variant matches the selected options — notify makes no sense here.
      const notifyButton = form.querySelector("[data-notify-back-in-stock]")
      if (notifyButton) notifyButton.classList.add("u-hide")
    })

    const price = document.getElementById(`price-${this.uniqueIdentifier}`)
    const stickyPrice = document.getElementById(`sticky-price-${this.uniqueIdentifier}`)

    if (price) this.setPriceUnavailable(price)

    if (stickyPrice) this.setPriceUnavailable(stickyPrice)
  }

  setPriceUnavailable(priceElement) {
    priceElement.classList.remove("price--on-sale")
    priceElement.classList.add("price--sold-out")
    priceElement.querySelector(".price__regular .price-item.price-item--regular").textContent =
      window.productStrings.price_unavailable
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  getProductVariantSelects() {
    return document.querySelectorAll(
      `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`,
    )
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects)
}

export { enableLazyVideos }

//Accordion docs: https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
class Accordion {
  constructor(el) {
    // Store the <details> element
    this.el = el
    // Store the <summary> element
    this.summary = el.querySelector("summary")
    // Store the <div class="content"> element
    this.content = el.querySelector(".content")

    // Store the animation object (so we can cancel it if needed)
    this.animation = null
    // Store if the element is closing
    this.isClosing = false
    // Store if the element is expanding
    this.isExpanding = false
    // Detect user clicks on the summary element
    this.summary.addEventListener("click", (e) => this.onClick(e))
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault()
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = "hidden"
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open()
      // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink()
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel()
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    )

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false)
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => (this.isClosing = false)
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`
    // Force the [open] attribute on the details element
    this.el.open = true
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand())
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel()
    }

    // Start a WAAPI animation
    this.animation = this.el.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    )
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true)
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => (this.isExpanding = false)
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open
    // Clear the stored animation
    this.animation = null
    // Reset isClosing & isExpanding
    this.isClosing = false
    this.isExpanding = false
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = ""
  }
}

document.querySelectorAll("details.accordion__wrapper").forEach((el) => {
  new Accordion(el)
})

export default Accordion
class LocalizationForm extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('a[data-input][data-value]').forEach((link) =>
      link.addEventListener('click', this.#onItemClick.bind(this))
    )
    this.querySelectorAll('[data-localization-search]').forEach((input) =>
      input.addEventListener('input', this.#onSearchInput.bind(this))
    )
  }

  #onItemClick(event) {
    event.preventDefault()
    const link = event.currentTarget
    const inputName = link.dataset.input
    const value = link.dataset.value
    if (!inputName || value === undefined) return
    const input = this.querySelector(`input[name="${inputName}"]`)
    if (input) {
      input.value = value
      this.querySelector('form')?.submit()
    }
  }

  #onSearchInput(event) {
    const searchInput = event.target
    const scope = searchInput.getAttribute('data-localization-search')
    const list = scope === 'region'
      ? this.querySelector('#panel-countries ul[role="list"]')
      : scope === 'language'
        ? this.querySelector('#panel-languages ul[role="list"]')
        : null
    if (!list) return
    const query = searchInput.value.trim().toLowerCase()
    for (const li of list.querySelectorAll(':scope > li')) {
      const link = li.querySelector('a')
      const text = link ? link.textContent.trim().toLowerCase() : ''
      li.hidden = query.length > 0 && !text.includes(query)
    }
  }
}

customElements.define('localization-form', LocalizationForm)

// "Notify when back in stock" — opens the Omnisend back-in-stock popup form.
// The button replaces "Add to cart" on sold-out variants (see VariantSelects
// .updateAddToCart). Delegated so it also covers sticky-bar / quick-view forms.
document.addEventListener("click", (event) => {
  const notifyButton = event.target.closest("[data-notify-back-in-stock]")
  if (!notifyButton) return

  event.preventDefault()

  const formId = window.omnisendBackInStockFormId
  if (!formId) return

  // Reflect the selected variant in the URL so Omnisend's back-in-stock form
  // associates the request with the right variant. Product pages only, to avoid
  // rewriting the URL from a collection / quick-view context.
  const variantId = notifyButton.dataset.variantId
  if (variantId && window.location.pathname.includes("/products/")) {
    const url = new URL(window.location.href)
    url.searchParams.set("variant", variantId)
    window.history.replaceState({}, "", url)
  }

  window.omnisend = window.omnisend || []
  window.omnisend.push(["openForm", formId])
})